export default "__VITE_ASSET__BaEnCS2o__"